export default {
  settingsPath: 'leverege.fotaApi'
};